import { FeatureType, Menu, MenuType } from "./menu-item-shared";

export const reportsMenu: Menu = {
  state: 'reports',
  name: 'menu.reports',
  icon: 'insert_drive_file',
  type: MenuType.Static,
  requiredFeatures: [ FeatureType.Reports ],
};
